var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "brandable-modal-page",
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c("div", { staticClass: "images-container" }, [
        _c("div", { staticClass: "floating-editor" }, [
          _c(
            "div",
            {
              staticClass: "arrow-container",
              on: {
                click: function() {
                  _vm.collapsed = !_vm.collapsed
                }
              }
            },
            [
              _c("div", {
                staticClass: "arrow",
                class: _vm.collapsed ? "right" : "left"
              })
            ]
          ),
          _vm._v(" "),
          !_vm.collapsed
            ? _c("div", { staticClass: "floating-edit-options" }, [
                _c("div", { staticClass: "floating-container" }, [
                  _c(
                    "div",
                    {
                      staticClass: "fixed-container clickable",
                      on: {
                        click: function() {
                          _vm.collapsedNotes = !_vm.collapsedNotes
                        }
                      }
                    },
                    [
                      _c("img", {
                        attrs: {
                          src:
                            "https://cdn.shopify.com/s/files/1/1363/8433/files/editicon_blue.svg?v=1711657195"
                        }
                      }),
                      _vm._v(" "),
                      _c("p", [_vm._v("Add Design Note")]),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "arrow",
                        class: _vm.collapsedNotes ? "down" : "up"
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.collapsedNotes,
                          expression: "!collapsedNotes"
                        }
                      ]
                    },
                    [
                      _c("textarea", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.designNotes,
                            expression: "designNotes"
                          }
                        ],
                        staticStyle: { width: "100%", resize: "none" },
                        attrs: {
                          placeholder: "Please add instructions",
                          type: "text"
                        },
                        domProps: { value: _vm.designNotes },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.designNotes = $event.target.value
                          }
                        }
                      })
                    ]
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "floating-container clickable",
                    on: {
                      click: function($event) {
                        return _vm.alignLogo(_vm.currentDesignIndex)
                      }
                    }
                  },
                  [_vm._m(0)]
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "exit", on: { click: _vm.closeModal } }, [
          _vm._v("< BACK")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "title-container mobile" }, [
          _c("p", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.selectedAddon.title) + " "),
            _c("br"),
            _vm._v(" "),
            _c("span", { staticClass: "turnaround" }, [
              _vm._v("This item typically has a 2-4 week turnaround")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "information-container" }, [
            _c(
              "div",
              {
                staticClass: "information-toggle",
                class: _vm.showDesc ? "toggle" : "",
                on: {
                  click: function() {
                    _vm.showDesc = !_vm.showDesc
                  }
                }
              },
              [
                _c("span", [_vm._v("Product Information ")]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "arrow",
                  class: !_vm.showDesc ? "down" : "up"
                })
              ]
            ),
            _vm._v(" "),
            _vm.showDesc
              ? _c("div", { staticClass: "desc-outer-container" }, [
                  _c("p", {
                    staticClass: "desc",
                    domProps: { innerHTML: _vm._s(_vm.productDesc) }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.showDesc ? _c("div", { staticClass: "curtain" }) : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "image-outer-container" }, [
          _c(
            "div",
            {
              staticClass: "main-image-container",
              attrs: { id: "draggableContainer" }
            },
            [
              _c("img", {
                staticClass: "main-image",
                attrs: { src: _vm.currentMainImage.src }
              }),
              _vm._v(" "),
              _vm.currentDesign && _vm.currentDesign.file
                ? _c(
                    "div",
                    {
                      staticClass: "image-editor-container",
                      class: _vm.designs[_vm.currentDesignIndex].shape
                        ? _vm.designs[_vm.currentDesignIndex].shape
                        : "",
                      attrs: { id: "iContainer" },
                      on: {
                        mouseover: function($event) {
                          _vm.designs[_vm.currentDesignIndex].active = true
                        },
                        mouseleave: function($event) {
                          return _vm.deactivateDesign()
                        }
                      }
                    },
                    [
                      _c(
                        "DDR",
                        {
                          attrs: {
                            id: "ddr",
                            active: _vm.designs[_vm.currentDesignIndex].active,
                            parent: false
                          },
                          on: { click: _vm.activateDesign },
                          model: {
                            value:
                              _vm.designs[_vm.currentDesignIndex].transform,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.designs[_vm.currentDesignIndex],
                                "transform",
                                $$v
                              )
                            },
                            expression: "designs[currentDesignIndex].transform"
                          }
                        },
                        [
                          _c("img", {
                            staticClass: "edit-image",
                            attrs: { src: _vm.currentDesign.img }
                          })
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.currentImageList.length > 1
            ? _c("div", { staticClass: "image-selectors" }, [
                _c(
                  "button",
                  {
                    staticClass: "image-back",
                    on: {
                      click: function($event) {
                        return _vm.changeImageIndex(false)
                      }
                    }
                  },
                  [_vm._v("<")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "image-fw",
                    on: {
                      click: function($event) {
                        return _vm.changeImageIndex(true)
                      }
                    }
                  },
                  [_vm._v(">")]
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "customization-container" },
        [
          _c("div", { staticClass: "title-container desktop" }, [
            _c("p", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.selectedAddon.title) + " "),
              _c("br"),
              _vm._v(" "),
              _c("span", { staticClass: "turnaround" }, [
                _vm._v("This item typically has a 2-4 week turnaround")
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "information-container" }, [
              _c(
                "div",
                {
                  staticClass: "information-toggle",
                  class: _vm.showDesc ? "toggle" : "",
                  on: {
                    click: function() {
                      _vm.showDesc = !_vm.showDesc
                    }
                  }
                },
                [
                  _c("span", [_vm._v("Product Information ")]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "arrow",
                    class: !_vm.showDesc ? "down" : "up"
                  })
                ]
              ),
              _vm._v(" "),
              _vm.showDesc
                ? _c("div", { staticClass: "desc-outer-container" }, [
                    _c("p", {
                      staticClass: "desc",
                      domProps: { innerHTML: _vm._s(_vm.productDesc) }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.showDesc ? _c("div", { staticClass: "curtain" }) : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm.designs.length > 0
            ? _c(
                "div",
                { staticClass: "design-container" },
                [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("1. Upload your designs")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.designs, function(design, i) {
                    return _c(
                      "div",
                      { staticClass: "design-input-container" },
                      [
                        _c("input", {
                          staticClass: "file-uploader",
                          attrs: { id: "file" + design.imgIndex, type: "file" },
                          on: {
                            change: function($event) {
                              return _vm.designUpload($event, i)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "outer-label",
                            attrs: { for: "file" + design.imgIndex }
                          },
                          [
                            !design.file
                              ? _c("div", { staticClass: "inner-label" }, [
                                  _c("span", { staticClass: "main-text" }, [
                                    _vm._v(
                                      " \n                            Upload " +
                                        _vm._s(design.name) +
                                        " Design "
                                    ),
                                    _c("img", {
                                      attrs: {
                                        src:
                                          "https://cdn.shopify.com/s/files/1/1363/8433/files/upload_purple.svg?v=1710535518"
                                      }
                                    })
                                  ])
                                ])
                              : _c("div", { staticClass: "inner-label" }, [
                                  _c("span", [
                                    _c("strong", [
                                      _vm._v(_vm._s(design.name) + ":")
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "main-text" }, [
                                    _vm._v(_vm._s(design.fileName))
                                  ])
                                ])
                          ]
                        ),
                        _vm._v(" "),
                        design.file
                          ? _c(
                              "p",
                              {
                                staticClass: "clear-image",
                                on: {
                                  click: function($event) {
                                    return _vm.clearImage(i)
                                  }
                                }
                              },
                              [_vm._v("X")]
                            )
                          : _vm._e()
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm._m(1)
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.nonColorOptions, function(option, i) {
            return _vm.hasVariants
              ? _c("div", { staticClass: "option-container" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v(
                      _vm._s(i + 2) +
                        ". Choose Available " +
                        _vm._s(option.name)
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "variants-button-container" },
                    _vm._l(option.values, function(variant, i) {
                      return _c(
                        "button",
                        {
                          key: variant,
                          staticClass: "happybox-button white",
                          class:
                            _vm.optionsSelected[option.position - 1] == variant
                              ? "selected"
                              : "",
                          on: {
                            click: function($event) {
                              return _vm.selectVariant(
                                option.position - 1,
                                variant
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(variant) +
                              "\n                "
                          )
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  option.name == "Printing Method"
                    ? _c("p", { staticClass: "legend" }, [
                        _c("img", {
                          staticClass: "i-icon",
                          attrs: {
                            src:
                              "https://cdn.shopify.com/s/files/1/1363/8433/files/info_icon_462d2e20-cb40-4eb2-9831-90a9babb7cce.svg?v=1700501409"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [
                          _vm._v(
                            "\n                    Your design is applied directly onto the products' surface by pushing ink through\n                    a fine mesh screen. This is one of our most popular decoration methods.\n                "
                          )
                        ])
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-container" }, [
            _c("p", { staticClass: "title" }, [
              _vm._v(
                _vm._s(_vm.nonColorOptions.length + 2) + ". Choose your message"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "blank-card-container" }, [
              _c("input", {
                attrs: { id: "blankCard", type: "checkbox" },
                domProps: { checked: _vm.isBlankMessage },
                on: {
                  change: function($event) {
                    return _vm.changeBlankMessage()
                  }
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "blankCard" } }, [
                _vm._v("Click here if you want your card blank")
              ])
            ]),
            _vm._v(" "),
            !_vm.isBlankMessage
              ? _c("div", { staticClass: "message-container" }, [
                  _c("label", { attrs: { for: "message" } }, [
                    _vm._v("Your Message:")
                  ]),
                  _vm._v(" "),
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.message,
                        expression: "message"
                      }
                    ],
                    attrs: {
                      placeholder: "Start typing here...",
                      maxlength: "200",
                      cols: "30",
                      rows: "3",
                      id: "message"
                    },
                    domProps: { value: _vm.message },
                    on: {
                      change: function($event) {
                        return _vm.changeMessage()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.message = $event.target.value
                      }
                    }
                  })
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isBlankMessage
              ? _c("div", { staticClass: "from-container" }, [
                  _c("label", { attrs: { for: "from" } }, [_vm._v("From:")]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.from,
                        expression: "from"
                      }
                    ],
                    attrs: {
                      placeholder: "Your Name",
                      maxlength: "200",
                      id: "from",
                      type: "text"
                    },
                    domProps: { value: _vm.from },
                    on: {
                      change: function($event) {
                        return _vm.changeFrom()
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.from = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _vm.isHandwritten
                    ? _c("p", { staticClass: "purple-span" }, [
                        _vm._v(
                          "Characters Remaining " +
                            _vm._s(_vm.remainingCharacters)
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mobile-sticky" }, [
            _c("p", { staticClass: "product-total" }, [
              _c("span", [_vm._v("Total:")]),
              _c("span", [_vm._v("$ " + _vm._s(_vm.currentPrice))])
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "happybox-button green border",
                on: { click: _vm.updateMainAddonProductQuantity }
              },
              [_vm._v("Add to Box")]
            )
          ])
        ],
        2
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("div", { staticClass: "global-spinner-container" }, [
            _c("div", { staticClass: "global-spinner" })
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fixed-container" }, [
      _c("img", {
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/align.svg?v=1711657195"
        }
      }),
      _vm._v(" "),
      _c("p", [_vm._v("Align Logo")]),
      _vm._v(" "),
      _c("div")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "legend" }, [
      _c("img", {
        staticClass: "i-icon",
        attrs: {
          src:
            "https://cdn.shopify.com/s/files/1/1363/8433/files/info_icon_462d2e20-cb40-4eb2-9831-90a9babb7cce.svg?v=1700501409"
        }
      }),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "Max file size is 10mb. Accepted file types are .png, .jpg, .jpeg and .svg"
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }